"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _filterBar = require("./filterBar.style");
var _CheckboxFilter = _interopRequireDefault(require("../CheckboxFilter/CheckboxFilter"));
var _DateFilter = _interopRequireDefault(require("../DateFilter/DateFilter"));
var _Icon = _interopRequireDefault(require("../../Icon"));
var _Button = _interopRequireDefault(require("../../Button"));
var _Input = _interopRequireDefault(require("../../Input"));
var _SavedFilterModal = _interopRequireDefault(require("../SavedFilterModal/SavedFilterModal"));
var _SaveNewFilterModal = _interopRequireDefault(require("../SaveNewFilterModal/SaveNewFilterModal"));
var _ConfigureFilterModal = _interopRequireDefault(require("../ConfigureFilterModal/ConfigureFilterModal"));
var _ShareFilter = _interopRequireDefault(require("../ShareFilter/ShareFilter"));
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
function FilterBar(_a) {
  var {
      className = 'filterBar',
      configuration,
      facets,
      filterData,
      currentFilter,
      showApplyButton,
      isSavedFiltersLoading = true,
      savedFilters,
      defaultColumns,
      cacheName,
      shareFilterUsersList,
      shareFilterModalVisible,
      isGeneratingSharableURL = false,
      isSendingInvitation = false,
      sharableUrlLink = '',
      onToggleShareFilterModal,
      onSavedFilterDelete,
      onApplySavedFilter,
      onCardToggle,
      onClose,
      onSaveColumnConfig,
      onSaveNewFilter,
      onCheckboxSelect,
      onCheckboxMultiSelect,
      onDateSelect,
      onSearchUpdateFacet,
      onFilterClear,
      onSavedFilterModalOpen,
      onShareFilterSubmit
    } = _a,
    rest = __rest(_a, ["className", "configuration", "facets", "filterData", "currentFilter", "showApplyButton", "isSavedFiltersLoading", "savedFilters", "defaultColumns", "cacheName", "shareFilterUsersList", "shareFilterModalVisible", "isGeneratingSharableURL", "isSendingInvitation", "sharableUrlLink", "onToggleShareFilterModal", "onSavedFilterDelete", "onApplySavedFilter", "onCardToggle", "onClose", "onSaveColumnConfig", "onSaveNewFilter", "onCheckboxSelect", "onCheckboxMultiSelect", "onDateSelect", "onSearchUpdateFacet", "onFilterClear", "onSavedFilterModalOpen", "onShareFilterSubmit"]);
  const [fieldMappings, setFieldMappings] = (0, _react.useState)(configuration === null || configuration === void 0 ? void 0 : configuration.fieldMappings);
  const [searchTerm, setSearchTerm] = (0, _react.useState)('');
  const [savedFilterModalIsOpen, setSavedFilterModalIsOpen] = (0, _react.useState)(false);
  const [configFilterModalIsOpen, setConfigFilterModalIsOpen] = (0, _react.useState)(false);
  const [saveNewFilterModalIsOpen, setSaveNewFilterModalIsOpen] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    setFieldMappings(configuration === null || configuration === void 0 ? void 0 : configuration.fieldMappings);
  }, [configuration === null || configuration === void 0 ? void 0 : configuration.fieldMappings]);
  const onSearch = e => {
    setSearchTerm(e.target.value);
    let searchTerm = e.target.value;
    const searchedFieldMappings = {};
    if (searchTerm.length) {
      searchTerm = searchTerm.toLowerCase().trim().split(' ').join('');
      Object.keys(configuration === null || configuration === void 0 ? void 0 : configuration.fieldMappings).forEach(item => {
        if (item.toLowerCase().trim().split(' ').join('').includes(searchTerm)) {
          searchedFieldMappings[item] = configuration === null || configuration === void 0 ? void 0 : configuration.fieldMappings[item];
        }
      });
      setFieldMappings(searchedFieldMappings);
    } else {
      setFieldMappings(configuration === null || configuration === void 0 ? void 0 : configuration.fieldMappings);
    }
  };
  const onClear = () => {
    setSearchTerm('');
    setFieldMappings(configuration === null || configuration === void 0 ? void 0 : configuration.fieldMappings);
  };
  const toggleConfigFilterModal = () => {
    setConfigFilterModalIsOpen(prevState => !prevState);
  };
  const toggleSavedFilterModal = isOpen => {
    setSavedFilterModalIsOpen(isOpen);
    if (isOpen) {
      onSavedFilterModalOpen();
    }
  };
  const toggleNewFilterModal = isOpen => {
    setSaveNewFilterModalIsOpen(isOpen);
    onSavedFilterModalOpen();
  };
  const onClearFilter = () => {
    onFilterClear();
  };
  return (0, _jsxRuntime.jsxs)(_filterBar.Components.FilterBarWrapper, (0, _extends2["default"])({
    className: className
  }, rest, {
    children: [(0, _jsxRuntime.jsxs)(_filterBar.Components.FilterBarCard, {
      children: [(0, _jsxRuntime.jsxs)("div", {
        children: [(0, _jsxRuntime.jsxs)(_filterBar.Components.FilterBarHeaderTitleWrapper, {
          children: [(0, _jsxRuntime.jsx)(_filterBar.Components.FilterBarHeaderTitle, (0, _extends2["default"])({
            variant: "h5",
            "data-testId": "filter-bar-header-title"
          }, {
            children: "Apply filter"
          })), (0, _jsxRuntime.jsx)(_filterBar.Components.FilterHeaderCloseIcon, (0, _extends2["default"])({
            onClick: () => onClose(),
            "data-testId": "filter-bar-header-close-icon"
          }, {
            children: (0, _jsxRuntime.jsx)(_Icon["default"], {
              name: "times",
              size: "24"
            })
          }))]
        }), (0, _jsxRuntime.jsxs)(_filterBar.Components.FilterHeaderSaveWrapper, {
          children: [(0, _jsxRuntime.jsxs)(_filterBar.Components.FilterHeaderSaveWrapperArea, {
            children: [(0, _jsxRuntime.jsx)(_filterBar.Components.FilterHeaderSaveWrapperText, {
              children: currentFilter.name || 'Custom Filter'
            }), currentFilter.isEdited && (0, _jsxRuntime.jsx)(_filterBar.Components.FilterHeaderSaveWrapperText, (0, _extends2["default"])({
              className: "edited"
            }, {
              children: "- Edited"
            }))]
          }), currentFilter.isEdited && (0, _jsxRuntime.jsx)(_Button["default"], {
            label: "Save as",
            fit: "small",
            "data-testId": "filter-bar-header-save-as-button",
            onClick: () => toggleNewFilterModal(true)
          })]
        }), (0, _jsxRuntime.jsx)(_Input["default"], {
          id: "filter-search-input",
          placeholder: "Search for filter",
          clearButton: true,
          value: searchTerm,
          icon: "magnifying-glass",
          "icon-position": "left",
          onClear: onClear,
          onChange: e => onSearch(e)
        })]
      }), (0, _jsxRuntime.jsx)(_filterBar.Components.FilterBarBody, {
        children: Object.keys(fieldMappings).map((fieldMapping, key) => {
          return fieldMappings[fieldMapping].type === 'checkbox' && fieldMappings[fieldMapping].isVisible ? (0, _jsxRuntime.jsx)(_CheckboxFilter["default"], {
            title: fieldMapping,
            "data-testId": "filter-bar-body-checkbox-".concat(fieldMapping),
            fieldData: fieldMappings[fieldMapping],
            expanded: fieldMappings[fieldMapping].expanded,
            loading: !!fieldMappings[fieldMapping].isLoading,
            options: facets[fieldMappings[fieldMapping].fieldName] ? facets[fieldMappings[fieldMapping].fieldName] : [],
            values: filterData[fieldMapping] && filterData[fieldMapping][0] ? filterData[fieldMapping][0].values : [],
            onSearchUpdateFacet: onSearchUpdateFacet,
            onCheckboxSelect: onCheckboxSelect,
            onCheckboxMultiSelect: onCheckboxMultiSelect,
            onCardToggle: onCardToggle
          }, key) : !searchTerm && fieldMappings[fieldMapping].type === 'date' && fieldMappings[fieldMapping].isVisible && (0, _jsxRuntime.jsx)(_DateFilter["default"], {
            title: fieldMapping,
            "data-testId": "filter-bar-body-date-".concat(fieldMapping),
            expanded: fieldMappings[fieldMapping].expanded,
            fieldData: fieldMappings[fieldMapping],
            fromDate: filterData[fieldMapping] && filterData[fieldMapping][0] ? filterData[fieldMapping][0].from : '',
            toDate: filterData[fieldMapping] && filterData[fieldMapping][0] ? filterData[fieldMapping][0].to : '',
            relativeDate: filterData[fieldMapping] && filterData[fieldMapping][0] ? filterData[fieldMapping][0].relative_date : '',
            fromDays: filterData[fieldMapping] && filterData[fieldMapping][0] ? filterData[fieldMapping][0].from_days : '',
            toDays: filterData[fieldMapping] && filterData[fieldMapping][0] ? filterData[fieldMapping][0].to_days : '',
            filterType: filterData[fieldMapping] && filterData[fieldMapping][0] ? filterData[fieldMapping][0].type : '',
            onCardToggle: onCardToggle,
            onDateSelect: onDateSelect
          }, key);
        })
      }), (0, _jsxRuntime.jsxs)(_filterBar.Components.FilterBarFooter, {
        children: [(0, _jsxRuntime.jsx)(_filterBar.Components.FilterBarFooterShareBlock, {
          children: (0, _jsxRuntime.jsx)(_Button["default"], {
            label: "Share Filter",
            variant: "outlined",
            "icon-position": "left",
            icon: "share",
            width: "full-width",
            "data-testId": "filter-bar-share-filter-button",
            onClick: onToggleShareFilterModal
          })
        }), (0, _jsxRuntime.jsxs)(_filterBar.Components.FilterBarFooterTertiaryBlock, {
          children: [(0, _jsxRuntime.jsx)(_Button["default"], {
            label: "Configure filters",
            variant: "outlined",
            "icon-position": "left",
            icon: "sliders-horizontal",
            width: "full-width",
            "data-testId": "filter-bar-configure-filters-button",
            onClick: toggleConfigFilterModal
          }), (0, _jsxRuntime.jsx)(_Button["default"], {
            label: "Saved Filters",
            variant: "outlined",
            "icon-position": "left",
            icon: "floppy-disk",
            width: "full-width",
            "data-testId": "filter-bar-saved-filters-button",
            onClick: () => toggleSavedFilterModal(true)
          })]
        }), showApplyButton && (0, _jsxRuntime.jsx)(_filterBar.Components.FilterBarFooterSaveBlock, {
          children: (0, _jsxRuntime.jsx)(_Button["default"], {
            label: "Apply Filter",
            variant: "filled",
            width: "full-width",
            "data-testId": "filter-bar-apply-filter-button"
          })
        }), (0, _jsxRuntime.jsx)(_filterBar.Components.FilterBarFooterClearBlock, {
          children: (0, _jsxRuntime.jsx)(_filterBar.Components.FilterBarFooterClearButton, (0, _extends2["default"])({
            onClick: onClearFilter,
            "data-testId": "filter-bar-clear-filter-button"
          }, {
            children: "Clear Filter"
          }))
        })]
      })]
    }), savedFilterModalIsOpen && (0, _jsxRuntime.jsx)(_SavedFilterModal["default"], {
      isLoading: isSavedFiltersLoading,
      savedFilters: savedFilters,
      onModalClose: () => toggleSavedFilterModal(false),
      onSavedFilterDelete: onSavedFilterDelete,
      onApplySavedFilter: onApplySavedFilter
    }), configFilterModalIsOpen && (0, _jsxRuntime.jsx)(_ConfigureFilterModal["default"], {
      configuration: configuration.fieldMappings,
      defaultColumns: defaultColumns,
      cacheName: cacheName,
      onModalClose: toggleConfigFilterModal,
      onSaveColumnConfig: onSaveColumnConfig
    }), saveNewFilterModalIsOpen && (0, _jsxRuntime.jsx)(_SaveNewFilterModal["default"], {
      isLoading: isSavedFiltersLoading,
      isUpdate: !!currentFilter.name,
      currentFilter: currentFilter === null || currentFilter === void 0 ? void 0 : currentFilter.name,
      savedFilters: savedFilters,
      onClose: toggleNewFilterModal,
      onSaveNewFilter: onSaveNewFilter
    }), shareFilterModalVisible && (0, _jsxRuntime.jsx)(_ShareFilter["default"], {
      shareFilterUsersList: shareFilterUsersList,
      isGeneratingSharableURL: isGeneratingSharableURL,
      isSendingInvitation: isSendingInvitation,
      sharableUrlLink: sharableUrlLink,
      onToggleShareFilterModal: onToggleShareFilterModal,
      onShareFilterSubmit: onShareFilterSubmit
    })]
  }));
}
var _default = exports["default"] = FilterBar;